export default {
  "content": "<path d=\"M1.8 3.604a1.8 1.8 0 001.8-1.802 1.8 1.8 0 10-1.8 1.802zm7.2 0a1.8 1.8 0 001.8-1.802A1.8 1.8 0 109 3.604zm7.2 0A1.8 1.8 0 0018 1.802a1.8 1.8 0 10-1.8 1.802z\" fill=\"#999FAC\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "height": "4",
    "viewBox": "0 0 18 4",
    "width": "18",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};